var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      attrs: {
        name: "modal-result-photo",
        id: "result-photo-modal",
        width: 800,
        pivotY: 0.2,
        height: "auto"
      },
      on: { "before-open": _vm.urlForPhoto }
    },
    [_c("img", { staticClass: "result-photo", attrs: { src: _vm.photo } })]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }